import { Icon } from "@circle-react/components/shared/Icon";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

interface BuyButtonProps {
  dataTestId: string;
  disabled: boolean;
  label: string;
}

export const BuyButton = ({ disabled, label, dataTestId }: BuyButtonProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_buttons_enabled");

  const compassProps = isCircleV4
    ? ({
        startIcon: "lock",
      } as const)
    : {};

  return (
    <Button
      type="submit"
      extraLarge
      variant="circle"
      disabled={disabled}
      full
      data-testid={dataTestId}
      className="flex flex-row items-center justify-center gap-x-2"
      {...compassProps}
    >
      {!isCircleV4 && <Icon size={20} type="20-lock" />}
      {label}
    </Button>
  );
};
